import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'
import { IntlActions } from 'react-redux-multilingual'
import './index.scss';

// Import custom components
import store from './store';
import translations from './constants/translations'
import { receiveProducts, getAllProducts, addToCartRoot,clearCart, setPromocodes } from './actions'
import Fashion from './components/layouts/fashion';
import NoSideBar from "./components/products/no-sidebar";
// Extra Pages
import PageNotFound from './components/pages/404'

// Features
import Layout from './components/app'
// import Seats from './components/seats'
import Cart from './components/cart'
import checkOut from './components/checkout'
import orderSuccess from './components/checkout/success-page'
import { getProducts, getPromocodes } from './api';

var lang = localStorage.getItem('locale-lang');

if(lang==null){
	lang='en';
}

class Root extends React.Component {

    render() {
				store.dispatch(clearCart());
				const response = getProducts();
				response.then(async (data) => {
				//	await store.dispatch(receiveProducts(data));
					await store.dispatch(getAllProducts());
					data.forEach(p => {
						if (p.is_active) {
							const cartItem = {
								"id": 2,
								"name": "Product A",
								"price": 50,
								"salePrice": 50,
								"discount": 0,
								"pictures": ["/assets/images/fashion/product/3.jpg", "/assets/images/fashion/product/6.jpg", "/assets/images/fashion/product/10.jpg", "/assets/images/fashion/product/12.jpg"],
								"shortDetails": "Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem,",
								"description": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
								"stock": 6,
								"new": true,
								"sale": false,
								"category": "all",
								"colors": ["gray", "orange"],
								"size": ["M", "L", "XL"],
								"tags": ["caprese", "puma"],
								"rating": 5,
								"variants": [
								{
									"color": "gray",
									"images": p.url,
								},
								{
									"color": "orange",
									"images": "/assets/images/fashion/product/product.png"
								}],
							};
							cartItem.id = p.id;
							cartItem.name = p.product_name;
							cartItem.shortDetails = p.product_description;
							cartItem.price = (p.price / 100.0).toFixed(2);
							cartItem.total = (p.price / 100.0).toFixed(2);
							cartItem.min_order = p.min_order;
							cartItem.max_order = p.max_order;
							
							cartItem.stock = p.product_quantity - p.units_sold;
							// cartItem.variants[0].images = p.url;
							cartItem.source = p;
							store.dispatch(addToCartRoot(cartItem, 0));
						}
					});
					store.dispatch(IntlActions.setLocale(lang));
				})

				const promocodes = getPromocodes();
				promocodes.then((data) => {
					console.log(data);
					store.dispatch(setPromocodes(data));
				})

        return(
        	<Provider store={store}>
						<IntlProvider translations={translations} locale='en'>
							<BrowserRouter basename={'/'} >
								<ScrollContext>
									<Layout>
										<Switch>
											<Route exact path="/" component={Cart}/>
											<Route exact path="/checkout" component={checkOut}/>
											<Route exact path="/orderSuccess" component={orderSuccess}/>
											<Route path={`${process.env.PUBLIC_URL}/no-sidebar/product/:id`} component={NoSideBar}/>
											<Route component={PageNotFound} />
										</Switch>
									</Layout>
								</ScrollContext>
							</BrowserRouter>
						</IntlProvider>
					</Provider>
    	);
    }
}

ReactDOM.render(<Root />, document.getElementById('root'));


